<app-unit-fix-panel
  *ngIf="showsUnits; else reason"
  [view]="unitFix ?? loadingUnits"
  [syncEnabled]="syncEnabled"
  [idPrefix]="idPrefix"
  (groupUnitChange)="unitGroupChange.emit($event)"
  (itemUnitChange)="unitItemChange.emit($event)"
  (apply)="unitApply.emit()"
  (close)="close.emit()"
></app-unit-fix-panel>

<ng-template #reason>
  <div class="efp">
    <ng-container *ngIf="group.fixed; else open">
      <div class="mk-banner ok" role="status">
        <i class="bi bi-check-circle" aria-hidden="true"></i>
        <div><b>Fixed.</b> {{ fixedText }}</div>
      </div>
    </ng-container>

    <ng-template #open>
      <p class="efp-what">{{ group.whatToDo }}</p>
      <div class="mk-banner">
        <i class="bi bi-info-circle" aria-hidden="true"></i>
        <div>{{ group.clears }}</div>
      </div>

      <ng-container [ngSwitch]="group.fix">
        <app-sales-group-fix
          *ngSwitchCase="'sales-group'"
          [store]="store"
          [count]="group.count"
          [syncEnabled]="syncEnabled"
          [idPrefix]="idPrefix"
        ></app-sales-group-fix>
        <app-refresh-groups-fix
          *ngSwitchCase="'refresh-groups'"
          [store]="store"
          [syncEnabled]="syncEnabled"
          [lastRead]="groupsLastRead"
          [idPrefix]="idPrefix"
        ></app-refresh-groups-fix>
        <app-code-fix *ngSwitchCase="'code'" [store]="store" [idPrefix]="idPrefix"></app-code-fix>
        <app-code-fix *ngSwitchCase="'name'" [store]="store" [idPrefix]="idPrefix"></app-code-fix>
        <app-category-fix *ngSwitchCase="'categories'" [store]="store" [syncEnabled]="syncEnabled" [idPrefix]="idPrefix"></app-category-fix>
        <app-rematch-fix
          *ngSwitchCase="'rematch'"
          [store]="store"
          [syncEnabled]="syncEnabled"
          (openMatching)="openMatching.emit($event)"
        ></app-rematch-fix>
        <app-support-fix *ngSwitchCase="'support'" [group]="group"></app-support-fix>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="showsRecords">
      <div class="tag">{{ group.count === 1 ? '1 record' : group.count + ' records' }}</div>
      <div class="mk-card efp-record" *ngFor="let record of group.records; trackBy: trackRecord">
        <b class="efp-name">{{ record.name }}</b>
        <span class="mk-muted" *ngIf="codeOf(record) as code">{{ code }}</span>
        <span class="mk-muted efp-detail">{{ record.detail }}</span>
      </div>
      <p class="mk-muted efp-shown" *ngIf="moreThanShown">Showing {{ group.records.length }} of {{ group.count }}.</p>
    </ng-container>

    <div class="efp-footer">
      <p class="efp-hint" *ngIf="syncHint">{{ syncHint }}</p>
      <div class="efp-actions">
        <button type="button" class="btn-secondary" (click)="close.emit()">{{ group.fixed ? 'Done' : 'Close' }}</button>
        <button type="button" class="btn-teal-gradient" *ngIf="mainLabel" (click)="action.emit()">{{ mainLabel }}</button>
        <button
          type="button"
          class="btn-teal-gradient"
          *ngIf="categoryApply as apply"
          [disabled]="apply.disabled"
          (click)="store.categories.applyItems()"
        >
          {{ apply.label }}
        </button>
        <button
          type="button"
          class="btn-teal-gradient"
          *ngFor="let target of syncTargets; trackBy: trackTarget"
          [disabled]="!syncEnabled || syncBusy"
          (click)="sync.emit(target)"
        >
          {{ syncLabel(target) }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
